// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ListIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13 22H3a1 1 0 010-2h10a1 1 0 010 2zm7-4H4a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2zM4 4v12h16V4z"/></svg>'} />;

ListIcon.displayName = 'ListIcon';

export default ListIcon;
